import { IDay, RemovedReasonType } from 'fitbeat.models';
import moment from 'moment-timezone';
import { UserWorkoutSession } from '../entities';

enum BookingState {
  ConfirmedBooking,
  ProvisionalBooking,
  BookingInvite,
}

export const getFirstBookingForDay = (
  bookings: UserWorkoutSession[],
  day: IDay,
  getGymTimezone: (session: UserWorkoutSession) => string,
) => (
  bookings.find((booking: UserWorkoutSession) =>
    isWorkoutOnDateInTimezone(day, booking, getGymTimezone) &&
    booking.bookingState === BookingState.ConfirmedBooking)
);

export const getAllBookingsForDay = (
  bookings: UserWorkoutSession[],
  day: IDay,
  getGymTimezone: (session: UserWorkoutSession) => string,
) => (
  bookings.filter((booking: UserWorkoutSession) =>
    isWorkoutOnDateInTimezone(day, booking, getGymTimezone) &&
    booking.bookingState === BookingState.ConfirmedBooking)
);

export const setBookingsRemovedState = (
  workoutSession: UserWorkoutSession, removedAt: Date | false, removedReason?: RemovedReasonType) => {
    workoutSession.removedAt = removedAt;
    if (removedReason) {
      workoutSession.removedReason = removedReason;
    }
    if (!removedAt) {
      delete workoutSession.removedReason;
    }
    return workoutSession;
  };

export const buildDayForBooking = (momentDate: moment.Moment, isToday: boolean) => {
  const startOfDay = moment(momentDate.valueOf())
    .startOf('day').valueOf();
  return {
    startOfDay,
    date: momentDate.valueOf(),
    dayIndex: momentDate.day(),
    displayName: momentDate.format('dd'),
    isToday,
    checkAfterEndDate: true,
  };
};

export const isWorkoutOnDateInTimezone = (
  day: IDay,
  booking: UserWorkoutSession,
  getGymTimezone: (session: UserWorkoutSession) => string,
) => {
  const { startTimeOfFirstExercise } = booking;
  const timezoneForGym = getGymTimezone(booking);
  const dateForGymInItsTimezone = moment.tz(startTimeOfFirstExercise, timezoneForGym).format('YYYYMMDD');
  const weekDaysDate = moment(day.date).format('YYYYMMDD');
  const endDateIsAfterToday = moment.tz(startTimeOfFirstExercise, timezoneForGym).isAfter(moment().tz(timezoneForGym));
  const endDateIsBeforeToday =
    moment.tz(startTimeOfFirstExercise, timezoneForGym).isBefore(moment().tz(timezoneForGym));

  if (dateForGymInItsTimezone === weekDaysDate && (endDateIsAfterToday || endDateIsBeforeToday)) {
    return true;
  }

  return false;
};
